import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetCheckoutURL, IResponseGetCheckoutURL } from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { checkoutURL } from "../../../utils/constants"
async function getCheckoutURL(
	{ ...rest }: IPropsGetCheckoutURL,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetCheckoutURL> =
			await apiPrivate.get(`${checkoutURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetCheckoutURL(
	data: IPropsGetCheckoutURL,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetCheckoutURL,
					unknown,
					IResponseGetCheckoutURL
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.CHECKOUTURL, ...Object.values(data)],
		queryFn: () => getCheckoutURL(data, apiPrivate),
		...options,
	})
}
